import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
// eslint-disable-next-line no-restricted-imports
import { lighten, makeStyles } from '@material-ui/core/styles'
import { useSelector } from "react-redux";
import TablePagination from "@material-ui/core/TablePagination";
import { Badge } from "react-bootstrap";
import ExportIcon from "@material-ui/icons/CloudDownload";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Paper,
  Tooltip,
  CircularProgress,
} from '@material-ui/core'

const headRows = [


  {
    id: 'device',
    numeric: false,
    disablePadding: false,
    label: 'Qurğunun adı',
  },
  {
    id: 'deviceModel ',
    numeric: false,
    disablePadding: false,
    label: 'Qurğu modeli ',
  },
  {
    id: 'direction',
    numeric: false,
    disablePadding: false,
    label: 'İstiqaməti',
  },

  {
    id: 'ip',
    numeric: false,
    disablePadding: false,
    label: 'IP ',
  },
  {
    id: 'devicePlace',
    numeric: false,
    disablePadding: false,
    label: 'Qurğu məkanı',
  },
  {
    id: 'deviceType ',
    numeric: false,
    disablePadding: false,
    label: 'Qurğu tipi ',
  },

  {
    id: 'createdDate',
    numeric: false,
    disablePadding: false,
    label: 'Yaradılma tarixi',
  },

  {
    id: 'serialNumber',
    numeric: false,
    disablePadding: false,
    label: 'Seriya nömrəsi',
  },
  {
    id: 'operation',
    numeric: false,
    disablePadding: false,
    label: 'Əməliyyat',
  },
  {
    id: 'message ',
    numeric: false,
    disablePadding: false,
    label: 'Mesaj',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Vəziyyət',
  },

  // {
  //   id: 'tools',
  //   numeric: false,
  //   disablePadding: true,
  //   label: 'Əməliyyatlar',
  // },
]

function EnhancedTableHead(props) {
  const { order,
    orderBy,
    onRequestSort, } = props

  return (
    <TableHead>
      <TableRow>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? 'right' : 'left'}
            sortDirection={orderBy === row.id ? false : false}
          >
            <TableSortLabel active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" ? onRequestSort(row.id) : null;
              }}>
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}


EnhancedTableHead.propTypes = {
  rowCount: PropTypes.number.isRequired,
  numSelected: PropTypes.number.isRequired,

};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },

  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  dense: {
    margin: theme.spacing(2),
  },
}))

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles()
  const { numSelected, onDeviceLogFilterExport } = props

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.actions}>

        <Tooltip title="Excel yüklə" placement="top">
          <button
            className="btn btn-sm btn-icon btn-bg-light btn-text-success btn-hover-success mr-2 h5 rounded-circle flex-shrink-0"
            onClick={onDeviceLogFilterExport}
          >
            <ExportIcon />
          </button>
        </Tooltip>
      </div>
    </Toolbar>
  )
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  progresRoot: {
    width: '100%',
    padding: '32px 16px',
  },
  progress: {
    margin: 'auto',
    display: 'block',
    color: '#072C8C',
  },
}))

export default function EnhancedTable({
  devices,
  isLoading,
  // setChooseDeviceId,
  setShowCreate,
  // setShowRemove,
  setShowRemoveDevices,
  // setShowEdit,
  deleteDevicesIds,
  setDeleteDevicesIds,
  isError,
  setSortField,
  setOrderByTable,
  sortField,
  orderBy,
  updateSkip,
  updateTake,
  count,
  filterInputsUpdate,
  filterInputs,
  onDeviceLogFilterExport,
  // setOpenView
}) {
  const classes = useStyles()
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const permissionList = useSelector(state => state.auth.permissionList)

  function handleRequestSort(property) {
    // const isDesc = sortField === property && !orderBy;
    const isDesc = sortField === property && orderBy === 'desc';


    // setOrderByTable(isDesc);
    setOrderByTable(isDesc ? 'asc' : 'desc');
    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }
  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = devices.map((n) => n.id)
      setDeleteDevicesIds(newSelecteds)
      return
    }
    setDeleteDevicesIds([])
  }
  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const isSelected = (id) => deleteDevicesIds.indexOf(id) !== -1

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
        <EnhancedTableToolbar
          numSelected={deleteDevicesIds.length}
          setShowCreate={setShowCreate}
          setShowRemoveDevices={setShowRemoveDevices}
          permissionList={permissionList}
          filterInputsUpdate={filterInputsUpdate}
          filterInputs={filterInputs}
          onDeviceLogFilterExport={onDeviceLogFilterExport}
        />

        <div className={classes.tableWrapper}>
          {devices.length ? (
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                numSelected={deleteDevicesIds.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={devices.length}
                order={orderBy}
                orderBy={sortField}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {devices.map((row, index) => {
                  const isItemSelected = isSelected(row.id)
                  const labelId = `enhanced-table-checkbox-${index}`
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      <TableCell component="th" id={labelId} scope="row">
                        {row.device ? row.device : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.deviceModel ? row.deviceModel : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.direction ? row.direction : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.ip ? row.ip : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.devicePlace ? row.devicePlace : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.deviceType ? row.deviceType : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.createdDate ? row.createdDate : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.serialNumber ? row.serialNumber : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.operation ? row.operation : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.message ? row.message : "-"}
                      </TableCell>
                      <TableCell padding="default" className="pr-4 px-4">
                        <Badge
                          variant={
                            row.status === "ERROR"
                              ? "info"
                              : row.status === "SUCCESS" ? "success" : "-"
                          }
                        >
                          {row.status === "SUCCESS"
                            ? "SUCCESS"
                            : row.status === "ERROR" &&
                            "ERROR"}
                        </Badge>
                      </TableCell>

                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          ) : !devices.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}
        </div>

        {count > 10 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}

            component="div"
            count={count}
            labelRowsPerPage={"Sətirlərin sayı"}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Əvvəlki səhifə",
            }}
            nextIconButtonProps={{
              "aria-label": "Növbəti səhifə",
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />)}
      </Paper>
    </div>
  )
}
